module.exports = {"version":2,"waiters":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/pricing-2017-10-15.waiters2.json
// module id = 1521
// module chunks = 3